<template>
    <div>
        <div class="pay-wrap">
            <div class="content">
                <p class="pay-tips"> 付款成功后请勿关闭此页面，请耐心等待自动回调订单，否则可能无法自动到账!</p>

                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">商品订单</span>
                        <span class="text">{{ detail.orderNo }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">商品详情</span>
                        <span class="text">{{ detail.title }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">购买数量</span>
                        <span class="text">{{ detail.inputNumber }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ detail.price * detail.inputNumber }}USDT</span>
                    </div>
                    <div class="info-list">
                        <span class="label">充值账号</span>
                        <span class="text">{{ detail.inputGT }}</span>
                    </div>
                </div>

                <div class="pay-list">
                    <p class="title">选择付款钱包</p>
                    <div v-for="(item, index) in payList" :key="index" class="item">
                        <div class="img-wrap">
                            <img :src="item.src" alt="">
                            <span class="title">{{ item.title }}</span>
                        </div>
                        <a-radio-group v-model:value="checkedVal">
                            <a-radio :value="item.value"></a-radio>
                        </a-radio-group>
                    </div>
                    <div class="btn-wrap">
                        <a-button class="btn" @click="onPay" type="primary">打开支付</a-button>
                    </div>
                </div>
            </div>
        </div>
         <!-- 二维码弹窗 -->
         <a-modal v-model:visible="qrVisible" title="比特派钱包支付" @ok="qrVisible = false" @cancel="qrVisible = false">
            <div class="qr-modal-content">
                <p class="qr-tips">请使用比特派钱包扫描下方二维码完成支付</p>
                <div class="qr-code-wrapper">
                    <canvas ref="qrCanvas"></canvas>
                </div>
                <p class="qr-tips">或复制以下链接到比特派钱包中打开:</p>
                <a-input v-model:value="bitpieUrl" readonly class="qr-input">
                    <template #addonAfter>
                        <a-button type="text" @click="copyUrl">复制</a-button>
                    </template>
                </a-input>
            </div>
        </a-modal>
    </div>
</template>

<script>
// import { testTX } from '../util/tronweb'; 
// import { getBuildRawTransaction } from "../util/api"
import QRCode from 'qrcode';
import { buildWalletPayUrl, buildWalletPayRoute, resolveGameGroupId, openWalletPayDeeplink } from '../util/deeplink';
import { persistWalletClientChoice } from '../util/walletClient';

export default {
    name: 'PaymentPage',
    props: {
        msg: String
    },
    components: {
    },
    data() {
        return {
            detail: {},
            checkedVal: '',
            referralCode:'',
            gameGroupId: undefined,
            tgNo:'',
            qrVisible: false,
            bitpieUrl: '',
            payList: [
                { title: 'imToken钱包', src: require('../assets/imtoken.jpg'), value: 'imtoken', checked: false },
                { title: 'Tokenpocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket', checked: true },
                { title: 'BitGet钱包', src: require('../assets/bitget.jpg'), value: 'bitget', checked: false },
                { title: 'TronLink钱包', src: require('../assets/tronlink.jpg'), value: 'tronlink', checked: false },
                // { title: '比特派钱包', src: require('../assets/biep.png'), value: 'bitpie', checked: false },
            ]
        }
    },
    mounted() {
        
        const data = JSON.parse(this.$route.params.data); // 解析字符串为对象
        this.detail = data
        const referralCode = data.referral_code;
        console.log(data)
        this.referralCode = referralCode;
        this.gameGroupId = resolveGameGroupId(data);
        this.tgNo = data.inputGT;

        

        if (window.tronWeb && window.tronWeb.ready) {
            console.log("✅ TronLink 发现！");
            this.$router.push(
                buildWalletPayRoute(this.detail.orderNo, this.referralCode, this.gameGroupId)
            );
            
        } else {
            console.error("❌ 未安装 TronLink");
        }

    },
    methods: {
        getUserApploenMethod() {
            // 
        },
        onCheck(val) {
            this.checkedVal = val
        },
        walletPayOptions(extra = {}) {
            return { gameGroupId: this.gameGroupId, wallet: this.checkedVal, ...extra };
        },
        async onPay() {
            if (!this.checkedVal) {
                return;
            }
            persistWalletClientChoice(this.checkedVal);

            if (this.checkedVal === 'bitpie') {
                this.bitpieUrl = buildWalletPayUrl(
                    this.detail.orderNo,
                    this.referralCode,
                    this.walletPayOptions()
                );
                this.qrVisible = true;
                this.$nextTick(() => {
                    QRCode.toCanvas(this.$refs.qrCanvas, this.bitpieUrl, {
                        width: 200,
                        margin: 2
                    }, (error) => {
                        if (error) console.error(error);
                    });
                });
                return;
            }

            openWalletPayDeeplink(
                this.checkedVal,
                this.detail.orderNo,
                this.referralCode,
                this.gameGroupId,
            );
        },
        copyUrl() {
            navigator.clipboard.writeText(this.bitpieUrl).then(() => {
                this.$message.success('链接已复制到剪贴板');
            }).catch(err => {
                console.error('复制失败:', err);
                this.$message.error('复制失败');
            });
        }
    }
}
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .tips {
            padding: 20px 0px 10px;
            line-height: 22px;
            margin-bottom: 0;
            font-size: 16px;
            text-align: center;
        }

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;

            .title {
                font-weight: bold;
            }

            .item {
                display: flex;
                align-items: center;
                height: 60px;
                justify-content: space-between;
                border-bottom: #f8f8f8 2px solid;
            }

            .img-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    margin-right: 16px;
                }
            }
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                width: 100%;
                margin-top: 20px;
            }
        }

    }
}

/* 二维码弹窗样式 */
.qr-modal-content {
    text-align: center;
    padding: 20px;
    
    .qr-tips {
        margin-bottom: 15px;
        color: #666;
    }
    
    .qr-code-wrapper {
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }
    
    .qr-input {
        margin-top: 15px;
    }
}
</style>
